import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import {
    getInfluencerProfileSuccess,
    getInfluencerProfileFailure,
} from '../../actions/authActions/getInfluencerProfileActions';

function* getInfluencerProfile() {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getInfluencerProfile,
            isAuth: true,
        });
        yield put(
            getInfluencerProfileSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );
    } catch (error) {
        console.log('GET_INFLUENCER_PROFILE_FAILURE:', error?.response?.data);
        yield put(
            getInfluencerProfileFailure({
                status: error?.response?.data?.status,
                response: {},
                message: error?.response?.data?.message,
            })
        );
    }
}

function* getInfluencerProfileSaga() {
    yield takeLatest(actionTypes.GET_INFLUENCER_PROFILE_REQUEST, getInfluencerProfile);
}

export default getInfluencerProfileSaga;
